// Let content determine height, bounded by the space on the opening side.
// The 8px viewport inset matches the existing select-popover edge allowance.
const VIEWPORT_INSET = 8

export const SearchDropdown = {
  mounted() {
    this.window = this.el.ownerDocument.defaultView
    this.viewport = this.window.visualViewport
    this.scheduleFit = () => {
      this.window.cancelAnimationFrame(this.fitFrame)
      this.fitFrame = this.window.requestAnimationFrame(() => this.fit())
    }

    this.window.addEventListener("resize", this.scheduleFit)
    this.window.addEventListener("scroll", this.scheduleFit, true)
    this.viewport?.addEventListener("resize", this.scheduleFit)
    this.viewport?.addEventListener("scroll", this.scheduleFit)
    this.resizeObserver = new this.window.ResizeObserver(this.scheduleFit)
    this.resizeObserver.observe(this.el)
    this.resizeObserver.observe(this.el.parentElement)
    this.fit()
  },

  updated() {
    this.fit()
  },

  fit() {
    // Hidden dropdowns are measured when shown again by ResizeObserver.
    if (!this.el.getClientRects().length) return
    const viewportLeft = this.viewport?.offsetLeft ?? 0
    const viewportWidth = this.viewport?.width ?? this.window.innerWidth
    this.el.style.maxWidth = `${Math.max(0, Math.floor(viewportWidth - 2 * VIEWPORT_INSET))}px`
    const rect = this.el.getBoundingClientRect()
    // Measure against the original anchor, not our previous correction. This
    // lets a resize or navbar collapse undo a correction without drifting.
    const anchorLeft = rect.left - (parseFloat(this.el.style.translate) || 0)
    const left = Math.max(
      viewportLeft + VIEWPORT_INSET,
      Math.min(
        anchorLeft,
        viewportLeft + viewportWidth - VIEWPORT_INSET - rect.width,
      ),
    )
    this.el.style.translate = `${left - anchorLeft}px 0`
    const viewportTop = this.viewport?.offsetTop ?? 0
    const viewportBottom =
      viewportTop + (this.viewport?.height ?? this.window.innerHeight)
    const available =
      this.el.dataset.searchDropdownPosition === "above"
        ? rect.bottom - viewportTop
        : viewportBottom - rect.top
    const maxHeight = `${Math.max(0, Math.floor(available - VIEWPORT_INSET))}px`
    if (this.el.style.maxHeight !== maxHeight)
      this.el.style.maxHeight = maxHeight
  },

  destroyed() {
    this.window.removeEventListener("resize", this.scheduleFit)
    this.window.removeEventListener("scroll", this.scheduleFit, true)
    this.viewport?.removeEventListener("resize", this.scheduleFit)
    this.viewport?.removeEventListener("scroll", this.scheduleFit)
    this.resizeObserver.disconnect()
    this.window.cancelAnimationFrame(this.fitFrame)
  },
}
